import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { Prepack } from 'graphql-api/gql-api-interfaces';

import { NeverOutOfStockIconSize } from '../never-out-of-stock-icon/interfaces/never-out-of-stock-icon-size.enum';

@Component({
  selector: 'epc-pre-pack-header',
  templateUrl: './pre-pack-header.component.html',
  styleUrls: ['./pre-pack-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrePackHeaderComponent {
  public NeverOutOfStockIconSize = NeverOutOfStockIconSize;
  public imageMaxSizes = IMAGE_MAX_SIZES;

  @Input() public thumbnailsVisible: number;
  @Input() public prepack: Prepack;
  @Input() public opened: boolean;
  @Input() public totalItemsInPrepactText: string;
  @Input() public numberOfImagesToDisplay: number;
  @Input() public quantityLeft: number;
  @Input() public quantityWarningThreshold: string;
  @Input() public lowInvetoryWarningText: string;
  @Input() public showNoosIcon = true;
  @Input() public oneLineHeader = false;

  @Output() public clickedMaterialImage = new EventEmitter();

  public clickMaterialImage(variantId: string, event: Event) {
    event.stopPropagation();
    this.clickedMaterialImage.emit(variantId);
  }
}
